import { AssetCardComponent } from "./asset-card/asset-card.component";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { ColorPickerComponent } from "./color-picker/color-picker.component";
import { RatingComponent } from "./rating/rating.component";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { PipeModule } from "../pipe/pipe.module";
import { TreeModule } from "@odymaui/angular-tree-component";
import { HttpClientModule } from "@angular/common/http";
import { NgxFileDropModule } from "ngx-file-drop";
import { DragAndDropModule } from "angular-draggable-droppable";
import { HttpService } from "src/app/modules/assetModule/shared/services/http.service";
import { ColorPaletteComponent } from "./color-picker/color-palette/color-palette.component";
import { ColorSliderComponent } from "./color-picker/color-slider/color-slider.component";

let components = [
    AssetCardComponent,
    ColorPickerComponent,
    RatingComponent,
    ColorSliderComponent,
    ColorPaletteComponent
  ]
  
  @NgModule({
    declarations: components,
    imports: [
    BrowserModule,
    FormsModule,
    RouterModule,
    PipeModule,
    TreeModule,
    HttpClientModule,
    NgxFileDropModule,
    ReactiveFormsModule,
    DragAndDropModule
      ],

    providers: [HttpService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: components
  })
  export class SharedModule { }
